import React, { ComponentProps, useState } from 'react';

import { SonForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ParticipationButton } from '../../../_lib/components/ParticipationButton';
import { ContentLink } from '../../../_lib/components/ContentLink';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { asFetchableView } from '../../../_lib/ViewFetcher';

export type UserLink = {
  name: string;
  url: string;
};

type EventParticipationDefaultProps = {
  leaveForm: SonForm<any>;
  joinForm: SonForm<any>;
  userLink: UserLink;
  participant: boolean;
};

function EventParticipationDefault({ leaveForm, joinForm, userLink, participant }: EventParticipationDefaultProps) {
  const { t } = useSonTranslation('EventParticipation');

  const [currentParticipating, setCurrentParticipating] = useState(participant);

  return (
    <section className="event-participation">
      <h2 className="invisible">{t('defaultView.heading')}</h2>
      <ContentParagraph>
        <ContentLink to={userLink.url}>{userLink.name}</ContentLink>
        {', '}
        <span aria-live="polite">
          {currentParticipating ? t('defaultView.status.participating') : t('defaultView.status.notParticipating')}
        </span>
      </ContentParagraph>
      <div className="event-participation__button">
        <ParticipationButton
          form={currentParticipating ? leaveForm : joinForm}
          participating={currentParticipating}
          onSuccess={() => setCurrentParticipating(prev => !prev)}
        />
      </div>
    </section>
  );
}

export const EventParticipationDefaultView = asFetchableView(EventParticipationDefault);
export type EventParticipationDefaultView = ComponentProps<typeof EventParticipationDefault>;
